// Helpers for importing loosely-structured spreadsheet rows.

export const str = (v: any): string => (v == null ? '' : String(v).trim());

export const num = (v: any): number | undefined => {
  if (v == null || v === '') return undefined;
  const d = String(v).replace(/[^\d]/g, '');
  return d ? Number(d) : undefined;
};

// Find a value in a row by fuzzy header match (case-insensitive "includes").
export function pick(row: Record<string, any>, keys: string[]): any {
  for (const k of Object.keys(row)) {
    const nk = k.toLowerCase().trim();
    if (keys.some((x) => nk.includes(x))) return row[k];
  }
  return undefined;
}

// Normalize Excel/CSV dates (Date object, Excel serial number, dd/mm/yyyy...) to yyyy-mm-dd.
export function normalizeDate(v: any): string {
  if (!v) return '';
  if (v instanceof Date) return v.toISOString().slice(0, 10);
  if (typeof v === 'number') {
    const d = new Date(Math.round((v - 25569) * 86400 * 1000));
    return isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
  }
  const s = String(v).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return s.slice(0, 10);
  const m = s.match(/(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{2,4})/);
  if (m) {
    const dd = m[1].padStart(2, '0');
    const mm = m[2].padStart(2, '0');
    const yy = m[3].length === 2 ? '20' + m[3] : m[3];
    return `${yy}-${mm}-${dd}`;
  }
  return '';
}
